import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BASE_URL, TagDisplayStatus } from '../utils/constants';
import { KeeperType } from './keepers.resource';
import { DeepPartial } from '../utils/types';

export type DisplayStatusVisualizationConfig = {
  [status in TagDisplayStatus]: string;
};

export type KeeperTypeVisualizationConfig = {
  [type in KeeperType]: DisplayStatusVisualizationConfig;
};

export type KeeperVisualizationConfig = {
  icons: DisplayStatusVisualizationConfig;
  multitagIcons: DisplayStatusVisualizationConfig;
  colors: DisplayStatusVisualizationConfig;
  multitagBaseColor: string;
};

export type GlobalVisualizationConfig = {
  keeperIcons: KeeperTypeVisualizationConfig;
  multitagIcons: DisplayStatusVisualizationConfig;
  keeperColors: KeeperTypeVisualizationConfig;
  multitagBaseColor: string;
};

export type AreaVisualizationConfig = {
  areaColor: string;
  areaDangerColor: string;
  areaHighlightColor: string;
};

export type UiVisualCustomization = {
  keepers: {
    [id: number]: KeeperVisualizationConfig;
  };
  labels: {
    [label: string]: GlobalVisualizationConfig;
  };
  global: GlobalVisualizationConfig & AreaVisualizationConfig;
};

@Injectable({
  providedIn: 'root',
})
export class UiVisualCustomizationResource {
  constructor(private httpClient: HttpClient) {
  }

  get(): Observable<DeepPartial<UiVisualCustomization>> {
    return this.httpClient.get<DeepPartial<UiVisualCustomization>>(`${BASE_URL}/ui_visual_customization`)
      .pipe(map((result) => result ?? {}));
  }

  update(config: DeepPartial<UiVisualCustomization>): Observable<void> {
    return this.httpClient.put<void>(`${BASE_URL}/ui_visual_customization`, config);
  }
}
